import { render, staticRenderFns } from "./StartupTrackersPopup.vue?vue&type=template&id=53cf61d6&scoped=true"
import script from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf61d6",
  null
  
)

export default component.exports